import React, {Component} from "react";
import PropTypes from "prop-types";
import className from "classnames";
import rowStyles from "./row.module.pcss";

const Row = ({children, rowWrapperClassName, rowContainerClassName, displayFlex, padding}) => {

  const displayFlexStyles = displayFlex ? rowStyles.displayFlex : null;
  const paddingStyles = padding ? rowStyles.padding : null;
  const rowWraperClassNames = className(rowStyles.row, paddingStyles, rowWrapperClassName);
  const rowContainerClassNames = className(rowStyles.rowContainer, rowContainerClassName, displayFlexStyles);

  return (
    <div className={rowWraperClassNames}>
      <div className={rowContainerClassNames}>
        {children}
      </div>
    </div>
  )
};

Row.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  displayFlex: PropTypes.bool,
  padding: PropTypes.bool,
  rowWrapperClassName: PropTypes.string,
  rowContainerClassName: PropTypes.string,
};

Row.defaultProps = {
  displayFlex: true,
  padding: true
};

export default Row;


// WEBPACK FOOTER //
// ./src/components/row/row.js